import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema, isEmpty } from "../../../Schema";
import { yesNoBooleanOptions } from "..";

export const isVisualized: FieldSchema = {
  grid: {
    displayed: true,
    order: 31,
    ignoredForSearch: true,
  },
  name: "isVisualized",
  data: {
    variant: DataVariants.ENUM,
    options: yesNoBooleanOptions,
    assignedValue: {
      getter: ({ isVisualized }) => isEmpty(isVisualized) ? false : isVisualized,
    },
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: { label: "Available in monitoring", type: InputTypes.SELECT },
};
